<script>
  import EnergyReportPreview from "@/components/energy-report-preview.vue";
  import EnergyUsageStatsCard from "@/components/energy-usage-stats-card";
  import * as api from "@/services/api.js";
  import {   NUMBER_FIXED_POINT,
  LOAD_THRESHOLD,
  TIME_INTERVAL_MINUTES,
  trailerUsage,
  wattTokWh,} from "@/services/solar.js";
  import {
    humanDate,
    humanTime,
    lastDayOfMonth,
    monthFromDate,
    timestampSql,
    weekOfYear,
  } from "@/services/datetime.js";
  import { ordinalFromNumber, roundNum } from "@/services/utils.js";

  export default {
    name: "energy-report-form",
    components: { EnergyReportPreview, EnergyUsageStatsCard },
    props: {
      dates: {
        type: Array,
        required: true,
      },
      period: {
        type: String,
        required: true,
      },
      selectedTrailers: {
        type: Array,
        default: () => [],
      },
      // trailerMap: {
      //   type: Object,
      //   default: () => ({})
      // }
    },
    data: () => ({
      collapseTrailers: false,
      companySelected: null,
      consumptionRate: 1.33,
      isLoading: true,
      loadThreshold: 200,
      options: {
        showRuntimeGauge: {
          label: "Runtime",
          value: true,
        },
        showPercentSolarGauge: {
          label: "Percent Solar",
          value: true,
        },
        showLogo: {
          label: "Logo",
          value: true,
        },
        showLogo: {
          label: "Logo",
          value: true,
        },
        showContact: {
          label: "Contact",
          value: true,
        },
        showTrailers: {
          label: "Trailers",
          value: true,
        },
        showGenerator: {
          label: "Generator",
          value: true,
        },
      },
      petrolRate: 0.0,
      petrolRateRegion: null,
      // petrolRateRegions: null,
      petrolRates: [],
      petrolRatesLoading: false,
      petrolRateType: "region",
      petrolModal: false,
      previewScale: 1,
      title1: "COMPANY - ENERGY REPORT",
      title2: null,
      title3: '"PROJECT TITLE"',
      titleSavings: "YOU SAVED THIS WEEK!",
      rangeModal: false,
      tempStats: {},
      tempStatsModal: false,
      trailers: {},
      trailersById: {},
      usageDates: null,
      usageDatesPrevious: null,
    }),
    computed: {
      companies() {
        return this.$store?.state?.companies || [];
      },
      company() {
        return this.$store?.state?.accountCompany || {};
      },
      companyDisplayed() {
        return {
          Name: this.company?.company_name || "",
          Contact: `${this?.company.first_name || ""} ${
            this?.company.last_name || ""
          }`,
          Email: this?.company?.email || "",
          Office: this?.company?.phone_mobile || "",
          Mobile: this?.company?.phone_office || "",
        };
      },
      hasEpsTrailer() {
        let hasEps = false;
        for (let t of this.selectedTrailers) {
          if (t?.name?.toLowerCase()?.includes("eps")) {
            hasEps = true;
            break;
          }
        }
        return hasEps;
      },
      optionsValues() {
        const options = {};
        for (let option in this.options) {
          options[option] = this.options[option].value;
        }
        return options;
      },
      petrolRatesDisplayed() {
        if (!this.petrolRateRegion || !this?.petrolRates?.length) return [];

        const rates = this.petrolRates.filter(
          (r) => r.region === this.petrolRateRegion
        );
        return rates
          .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
          .map((r) => ({ ...r, date: humanDate(r.date) }));
      },
      petrolRegions() {
        if (!this?.petrolRates?.length) return [];

        const regions = Array.from(
          new Set([...this.petrolRates.map((r) => r.region)])
        ).sort((a, b) => a.localeCompare(b));
        return regions;
      },
      petrolRateDetailText() {
        if (
          !this.petrolRatesDisplayed?.length ||
          this.petrolRateType !== "region"
        )
          return "";
        const rates = [...this.petrolRatesDisplayed].sort(
          (a, b) => a.diesel_price - b.diesel_price
        );
        const weekCount = this.petrolRatesDisplayed.length;
        let text = `${weekCount} week${weekCount === 1 ? "" : "s"}. $${
          rates[0].diesel_price
        }`;
        if (rates.length > 1)
          text += ` - $${rates[rates.length - 1].diesel_price}`;
        return text;
      },
      //unused?
      // selectedDatesText() {
      //   if (this.usageDates?.length) {
      //     const [start, end] = [...this.usageDates].sort((a, b) =>
      //       a.localeCompare(b)
      //     );
      //     return `${humanDate(start, true, false)} - ${humanDate(
      //       end,
      //       true,
      //       false
      //     )}`;
      //   }
      //   return undefined;
      // },
      trailersDisplayed() {
        return Object.keys(this.trailers).sort((a, b) =>
          this.trailersById?.[a]?.name?.localeCompare(
            this.trailersById?.[b]?.name
          )
        );
      },
      trailersUsedList() {
        let maxCount = 10;
        if (!this.optionsValues.showContact) maxCount += 5;
        if (!this.optionsValues.showGenerator) maxCount += 6;
        if (!this.optionsValues.showLogo) maxCount += 7;
        const maxCountAdj = maxCount - 1;
        // console.log("MAX COUNTTTTTT");
        // console.log(maxCount);
        const trailersByName = Object.keys(this.trailers).sort((a, b) =>
          this.trailersById?.[a]?.name?.localeCompare(
            this.trailersById?.[b]?.name
          )
        );
        let counts = {};
        for (let id of trailersByName) {
          if (!counts[this.trailers[id]]) {
            counts[this.trailers[id]] = 1;
          } else {
            counts[this.trailers[id]]++;
          }
        }
        let trailersByCount = Object.entries(counts)
          .sort((a, b) => b[1] - a[1])
          .map(([name, count]) => {
            return count <= 1 ? name : `${name} (x${count})`;
          });
        console.log("trailersByCount----");
        // console.log(trailersByCount);

        return trailersByCount?.length <= maxCount
          ? trailersByCount
          : [
              ...trailersByCount.slice(0, maxCountAdj),
              `+ ${trailersByCount.length - maxCountAdj} more`,
            ];
        // trailersByCount = Object.fromEntries(trailersByCount)
        console.log("---counts---");
        console.log(counts);
        console.log(trailersByCount);

        return trailersByName;
      },
      usageStatistics() {
        // const allResults = {};
        const combineableValues = [
          "co2Prevented",
          "fuelCostSaved",
          "gallonsFuelSaved",
          "hoursOffGrid",
          "hoursOnGrid",
          "totalkWh",
          "offGridkWh",
          "gridkWh",
          "reportedHours",
          "treesSaved",
        ];
        // EST 02-15
        const totals = {
          co2Prevented: 0.0,
          fuelCostSaved: 0.0,
          gallonsFuelSaved: 0.0,
          gridkWh: 0.0,
          hoursOffGrid: 0.0,
          hoursOnGrid: 0.0,
          offGridkWh: 0.0,
          percentHoursOffGrid: 0.0,
          percentOffGrid: 0.0,
          reportedHours: 0.0,
          totalkWh: 0.0,
          treesSaved: 0.0,
        };

        const rates = this?.pertrolRatesDisplayed || null
        const petrolRateRegion = this.petrolRateRegion
        const petrolRateType = this.region
        const valTemplate = {
          Battery:  0.0,
          Generator:  0.0,
          Grid: 0.0,
          Load: 0.0,
          PV: 0.0,
          SOC:  0.0,
        }

        const aggregatedByDateTime = {}
        for (let trailer in this.selectedTrailers) {
          for (let date in this.selectedTrailers[trailer].usage) {
            console.log(this.selectedTrailers[trailer].usage[date])
            if (!Object.values(this.selectedTrailers[trailer].usage[date])?.length) {
              continue
            }
            if (!aggregatedByDateTime[date]) {
                aggregatedByDateTime[date] = {}
              }
            for (let t in  this.selectedTrailers[trailer].usage[date]) {
          
              if (!aggregatedByDateTime[date][t]) {
                aggregatedByDateTime[date][t] = structuredClone(valTemplate)
              }
              for (let k in this.selectedTrailers[trailer].usage[date][t]) {
                aggregatedByDateTime[date][t][k] = aggregatedByDateTime[date][t][k] + parseFloat(this.selectedTrailers[trailer].usage[date][t][k])
              }
            }
          }
        }

        console.log('=====console.log(aggregatedByDateTime)====')
        console.log(aggregatedByDateTime)
        
        const usageByDate = {}
        for (let date in aggregatedByDateTime)  {
          usageByDate[date] = trailerUsage(
          aggregatedByDateTime[date] 
        );
        
        }
    
        
        console.log('=====console.log(usageByDate)====')
        console.log(usageByDate)
        

        //=====================================

        for (let trailer in this.selectedTrailers) {
          for (let date in this.selectedTrailers[trailer].usage) {
            console.log(this.selectedTrailers[trailer].usage[date])
            if (!Object.values(this.selectedTrailers[trailer].usage[date])?.length) {
              continue
            }
            const usage = trailerUsage(
              this.selectedTrailers[trailer].usage[date]
            );


            usage.gallonsFuelSaved = usage.hoursOffGrid * parseFloat(this.consumptionRate)
            console.log( usage.gallonsFuelSaved)
            const fuelRate = this.petrolRateType === "manual" ? parseFloat(this.petrolRate) : this.fuelCostByDate(date)
            usage.fuelCostSaved = usage.gallonsFuelSaved * fuelRate
            usage.co2Prevented = (parseFloat(usage.gallonsFuelSaved) * parseFloat(22.45)) / 2000
            usage.treesSaved =  parseFloat(usage.co2Prevented) * parseFloat(39)

            console.log("=======usageusageusage=======");
            console.log(usage);
            console.log("==============");
            combineableValues.forEach((cv) => {
              totals[cv] = totals[cv] + usage[cv];
            });


          }
        }
        console.log(totals)
        totals.percentOffGrid = Math.round(
          (totals.offGridkWh / totals.totalkWh) * 100
        );

        totals.percentHoursOffGrid = Math.round(
          (totals.hoursOffGrid / totals.reportedHours) * 100
        );
        //cleanup numbers
        for (let i in totals) {
          totals[i] = isNaN(totals[i]) ? 0 : Number(totals[i].toFixed(NUMBER_FIXED_POINT));
        }
        console.log(totals)

        totals.fuelCostSaved = Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(roundNum(totals.fuelCostSaved, 2));


        return totals
      },
      // usageStatisticsORIGI() {
      //   return;
      //   // ============================
      //   const fullDayIntervals = 288;
      //   const fullDayMinutes = 1440;
      //   const underLoadThreshold = [];
      //   const withinLoadThreshold = [];

      //   //todo, sort by trailer name (vehicle)
      //   //0.083 ~ 5min/60 (because we need hours not minutes)
      //   const intervalMinutes = 5;
      //   const trailers = [];
      //   // const totals = {
      //   //   time: {
      //   //     battery
      //   //   }
      //   // }
      //   const baseObj = {
      //     Battery: 0,
      //     Grid: 0,
      //     Load: 0,
      //     PV: 0,
      //     SOC: 0,
      //   };
      //   const baseTime = {
      //     external: 0,
      //     solar: 0,
      //     total: 0,
      //   };
      //   const totals = { ...baseObj, time: { ...baseTime } };
      //   const stats = {};

      //   this.selectedTrailers.forEach((trailer) => {
      //     const trailerTotals = {
      //       daily: {},
      //       monthly: {},
      //       total: { ...baseObj, time: { ...baseTime } },
      //     };
      //     let u = 0;
      //     for (let usageDate in trailer.usage) {
      //       const month = usageDate.substring(0, 7);
      //       if (!trailerTotals?.monthly?.[month]) {
      //         trailerTotals.monthly[month] = {
      //           ...baseObj,
      //           time: { ...baseTime },
      //         };
      //       }
      //       if (!trailerTotals?.daily?.[usageDate]) {
      //         trailerTotals.daily[usageDate] = {
      //           ...baseObj,
      //           time: { ...baseTime },
      //         };
      //       }

      //       for (let usageInterval in trailer.usage[usageDate]) {
      //         //determine solar or generator
      //         // console.log(usageDate)
      //         // console.log(usageInterval)
      //         if (
      //           parseFloat(trailer.usage[usageDate][usageInterval].Load) >=
      //           parseInt(this.loadThreshold)
      //         ) {
      //           // console.log('continue====')
      //           // console.log(totals.time.total)
      //           // console.log(totals.PV)
      //           // continue
      //           trailerTotals.total.time.total += intervalMinutes;
      //           trailerTotals.daily[usageDate].time.total += intervalMinutes;
      //           trailerTotals.monthly[month].time.total += intervalMinutes;
      //           totals.time.total += intervalMinutes;
      //         }
      //         // console.log(totals.time.total)
      //         // console.log(totals.PV)
      //         // console.log(trailerTotals.total.time.total)

      //         //new
      //         if (parseFloat(trailer.usage[usageDate][usageInterval].Grid) > 0) {
      //           totals.time.external += intervalMinutes;
      //           trailerTotals.total.time.external += intervalMinutes;
      //           trailerTotals.daily[usageDate].time.external += intervalMinutes;
      //           trailerTotals.monthly[month].time.external += intervalMinutes;
      //         }
      //         //solar determined at end total - external
      //         //

      //         for (let unit in trailer.usage[usageDate][usageInterval]) {
      //           // if (unit === 'PV') {
      //           //   // console.log(unit)
      //           //   console.log(trailer.usage[usageDate][usageInterval][unit])
      //           //   console.log(trailerTotals.total.PV)
      //           // }
      //           if (!totals[unit]) totals[unit] = 0;
      //           totals[unit] += parseFloat(
      //             trailer.usage[usageDate][usageInterval][unit]
      //           );
      //           if (!trailerTotals.total[unit]) trailerTotals.total[unit] = 0;
      //           trailerTotals.total[unit] += parseFloat(
      //             trailer.usage[usageDate][usageInterval][unit]
      //           );
      //           if (!trailerTotals.daily[usageDate][unit])
      //             trailerTotals.daily[usageDate][unit] = 0;
      //           trailerTotals.daily[usageDate][unit] += parseFloat(
      //             trailer.usage[usageDate][usageInterval][unit]
      //           );
      //           if (!trailerTotals.monthly[month][unit])
      //             trailerTotals.monthly[month][unit] = 0;
      //           trailerTotals.monthly[month][unit] += parseFloat(
      //             trailer.usage[usageDate][usageInterval][unit]
      //           );
      //         }
      //       }
      //       trailerTotals.total.time.solar =
      //         trailerTotals.total.time.total - trailerTotals.total.time.external;
      //       trailerTotals.daily[usageDate].time.solar =
      //         trailerTotals.daily[usageDate].time.total -
      //         trailerTotals.daily[usageDate].time.external;
      //       trailerTotals.monthly[month].time.solar =
      //         trailerTotals.monthly[month].time.total -
      //         trailerTotals.monthly[month].time.external;
      //     }
      //     trailers.push({ ...trailer, usage: { ...trailerTotals } });
      //     console.log({ trailers, totals });
      //     console.log(u);
      //     // this.tempStats = { trailers, totals }
      //     // this.tempStatsModal = true

      //     //to round
      //     //NUMBER
      //   });

      //   // console.log(totals)
      //   console.log("total PV: ", totals.PV);
      //   totals.time.solar = totals.time.total - totals.time.external;
      //   stats.totalHours = parseFloat(totals?.time?.total || 0) / 60;
      //   stats.totalWatt = parseFloat(totals.PV) + parseFloat(totals.Grid);
      //   stats.percentExternal =
      //     parseFloat(totals.Grid) / parseFloat(stats.totalWatt);
      //   // console.log(parseFloat(totals.PV))
      //   // console.log(parseFloat(stats.totalWatt))
      //   // console.log(parseFloat(totals.PV) / parseFloat(stats.totalWatt))
      //   // console.log('--')
      //   stats.percentSolar = parseFloat(totals.PV) / parseFloat(stats.totalWatt);
      //   stats.timeOnSolar =
      //     (parseFloat(totals.time.total) - parseFloat(totals.time.external)) / 60;
      //   stats.timeOnExternal = parseFloat(totals.time.external) / 60;
      //   stats.percentHoursOffGrid =
      //     parseFloat(stats.timeOnSolar) / parseFloat(stats.totalHours);
      //   stats.percentTimeOnExternal =
      //     parseFloat(stats.timeOnExternal) / parseFloat(stats.totalHours);
      //   //we are assuming this is coming in as mW
      //   stats.totalkWhUsed = parseFloat(stats.totalWatt) * 0.0000833;
      //   // stats.totalkWhUsed = (parseFloat(totalWattAdj) * parseFloat(stats.totalHours)) / 1000
      //   // stats.totalkWhUsed = (parseFloat(stats.totalWatt) * parseFloat(stats.totalHours)) / 1000
      //   console.log(parseFloat(stats.totalWatt));
      //   console.log(parseFloat(stats.totalHours));
      //   console.log(stats.totalkWhUsed);
      //   //we are assuming this is coming in as mW
      //   //Is this correct.. need to consult w/team
      //   stats.totalSolarkWhUsed = parseFloat(totals.PV) * 0.0000833;
      //   // stats.totalSolarkWhUsed = (parseFloat(totals.PV) * parseFloat(stats.timeOnSolar)) / 1000
      //   // stats.totalSolarkWhUsed = (parseFloat(totalSolWattAdj) * parseFloat(stats.timeOnSolar)) / 1000
      //   // console.log(parseFloat(totalSolWattAdj) * parseFloat(stats.timeOnSolar))
      //   // console.log((parseFloat(totalSolWattAdj) * parseFloat(stats.timeOnSolar)) / 1000)
      //   console.log(stats.totalSolarkWhUsed);

      //   //we are assuming this is coming in as mW
      //   stats.totalExternalkWhUsed = parseFloat(totals.Grid) * 0.0000833;
      //   // stats.totalExternalkWhUsed = (parseFloat(totalExtWattAdj) * parseFloat(stats.timeOnExternal)) / 1000
      //   // stats.totalExternalkWhUsed = (parseFloat(totals.Grid) * parseFloat(stats.timeOnExternal)) / 1000

      //   console.log("totalWatt", stats.totalWatt);
      //   console.log("percentSolar", stats.percentSolar);
      //   console.log("percentExternal", stats.percentExternal);
      //   console.log("timeOnSolar", stats.timeOnSolar);
      //   console.log("timeOnExternal", stats.timeOnExternal);
      //   console.log("percentHoursOffGrid", stats.percentHoursOffGrid);
      //   console.log("percentTimeOnExternal", stats.percentTimeOnExternal);
      //   console.log("total kWh used", stats.totalkWhUsed);
      //   console.log("total Solar kWh used", stats.totalSolarkWhUsed);
      //   console.log("total External kWh used", stats.totalExternalkWhUsed);

      //   console.log(stats);
      //   for (let stat in stats) {
      //     if (isNaN(stats[stat])) {
      //       stats[stat] = 0;
      //     } else {
      //       stats[stat] = roundNum(stats[stat]);
      //     }
      //   }

      //   //no decimals these values..

      //   stats.petrolRate = this.petrolRate;
      //   stats.gallonsFuelSaved = roundNum(
      //     (stats.totalHours - stats.timeOnExternal) *
      //       parseFloat(this.consumptionRate),
      //     1
      //   );
      //   console.log("----");
      //   console.log(
      //     parseFloat(stats.gallonsFuelSaved) * parseFloat(this.petrolRate)
      //   );
      //   console.log(
      //     roundNum(
      //       parseFloat(stats.gallonsFuelSaved) * parseFloat(this.petrolRate),
      //       2
      //     )
      //   );

      //   stats.fuelCostSaved =
      //     this.petrolRateType === "manual"
      //       ? parseFloat(stats.gallonsFuelSaved) * parseFloat(this.petrolRate)
      //       : this.calcFuelCostSavedByUsage(trailers);
      //   console.log("xxxxxxxxx");
      //   console.log(this.calcFuelCostSavedByUsage(trailers));
      //   console.log("xxxxxxxxx");

      //   stats.fuelCostSaved = Intl.NumberFormat("en-US", {
      //     style: "currency",
      //     currency: "USD",
      //   }).format(roundNum(stats.fuelCostSaved, 2));


      //   stats.co2Prevented = roundNum(
      //     (parseFloat(stats.gallonsFuelSaved) * parseFloat(22.45)) / 2000,
      //     1
      //   );
      //   stats.treesSaved = roundNum(
      //     parseFloat(stats.co2Prevented) * parseFloat(39),
      //     0
      //   );

      //   console.log("gallonsFuelSaved", stats.gallonsFuelSaved);
      //   console.log("fuelCostSaved", stats.fuelCostSaved);
      //   console.log("co2Prevented", stats.co2Prevented);
      //   console.log("treesSaved", stats.treesSaved);

      //   return { trailers, totals, stats };
      // },

      // selectedTrailers() {
      //   return this.$store?.state?.selectedTrailers || []
      // },
    },
    methods: {
      fuelCostByDate(date) {
        if (!this.petrolRatesDisplayed?.length) return 0.00
         let woy = weekOfYear(`${date} 00:00:00`);
         const rate = this.petrolRates.find(r => r.week == woy)
         return rate?.diesel_price? parseFloat(rate.diesel_price) : 0.00
      },
      calcFuelCostSavedByUsage(trailers = []) {
        /*
              relavant trailer array format:
              [{usage: {daily: {YYYY-MM-DD: {time: external: #, solar: #, total: #}}}}]
          */
        // stats.gallonsFuelSaved = roundNum((stats.totalHours - stats.timeOnExternal) * parseFloat(this.consumptionRate), 1)
        if (!this.petrolRatesDisplayed.length) return 0;
        let cost = 0;
        let ratesByWeek = {};
        for (let d of this.petrolRatesDisplayed) {
          // week return by API is 1 Week off!!
          // ratesByWeek[d.week] = d.diesel_price
          const woy = weekOfYear(d.date);
          ratesByWeek[woy] = d.diesel_price;
        }
        console.log(ratesByWeek);

        trailers.forEach((t) => {
          const dailyUsage = t.usage.daily;
          for (let date in dailyUsage) {
            console.log("date", date);
            let woy = weekOfYear(`${date} 00:00:00`);
            woy = woy.toString();
            console.log("woy", woy);
            const rate = ratesByWeek?.[woy] || 0;
            console.log("rate", rate);
            const totalHours =
              parseFloat(dailyUsage[date]?.time?.total || 0) / 60;
            // console.log('totalHours', totalHours)
            const totalExternal =
              parseFloat(dailyUsage[date]?.time?.external || 0) / 60;
            // console.log('totalExternal', totalExternal)
            const gallonsFuelSaved = roundNum(
              (totalHours - totalExternal) * parseFloat(this.consumptionRate),
              1
            );

            // console.log('gallonsFuelSaved', gallonsFuelSaved)
            const dailyCost = parseFloat(gallonsFuelSaved) * parseFloat(rate);
            // console.log(dailyCost)
            cost += dailyCost;
          }
        });
        return cost;
      },
      async getPetrolRates() {
        // const API_KEY = 'PCruXMdr9EAzgug2kUCTL5r1HqLVfcN55YgPDSxj'
        const API_KEY = process.env.VUE_APP_USDA_KEY || "";
        this.petrolRatesLoading = true;
        //testing
        // const start = '2025-05-04'
        // const end = '2025-05-10'

        //TODO: FIX START/END RANGE
        //IF PROVIDED DATES DONT INCLUDE A MONDAY
        //THEY DONT RETURN RESULTS
        // const start = `${this.dates[0].substring(0, 7)}-01`
        // const end = `${this.dates[1].substring(0, 7)}-28`
        let start = this.dates?.[0] || "";
        let end = this.dates?.[1] || start;
        const startSplit = start?.split('-') || null
        const endSplit = end?.split('-') || null
        //handle if full month is passed in for dates
        console.log(startSplit)
        console.log(endSplit)
        if (startSplit?.length === 2) {
          start = `${startSplit[0]}-${startSplit[1]}-01`
        }
        if (endSplit?.length === 2) {
          const lastDay = lastDayOfMonth(endSplit[0], endSplit[1])
          end = `${endSplit[0]}-${endSplit[1]}-${lastDay}`
        }
        console.log(start)
        console.log(end)

        const weekLength = 7 * 24 * 60 * 60 * 1000;
        //get a week  before and a week after to ensure all dates are covered...
        //api expects Mon start of week?
        const startAdjDt = new Date(`${start} 00:00:00`).getTime() - weekLength;
        const startAdjTs = timestampSql(startAdjDt, false);
        const endAdjDt = new Date(`${end} 23:59:00`).getTime() + weekLength;
        const endAdjTs = timestampSql(endAdjDt, false);
        // console.log(startAdjTs)
        // console.log(endAdjTs)
        // const url = `https://api.eia.gov/v2/petroleum/pri/gnd/data/?frequency=weekly&data[0]=value&facets[product][]=EPD2D&facets[product][]=EPD2DM10&facets[product][]=EPD2DXL0&start=${start}&end=${end}&sort[0][column]=period&sort[0][direction]=desc&offset=0&length=5000&api_key=${API_KEY}`
        const url =
          "https://agtransport.usda.gov/api/id/x88w-atzp.json?$select=*&$order=`date`+DESC&$limit=999&$offset=0&$where=`date` >= '" +
          startAdjTs +
          "' AND `date` < '" +
          endAdjTs +
          "'&$$read_from_nbe=true&$$version=2.1";
        const params = {
          frequency: "weekly",
          data: ["value"],
          facets: {
            product: ["EPD2D", "EPD2DM10", "EPD2DXL0"],
          },
          // start: '2025-05-04',
          // end: '2025-05-10',
          start,
          end,
          sort: [
            {
              column: "period",
              direction: "desc",
            },
          ],
          offset: 0,
          length: 50,
        };
        const headers = { "X-App-Token": API_KEY };
        // const headers = { 'X-Params': JSON.stringify(params) }

        const result = await fetch(url, { headers });
        const d = await result.json();
        console.log(d);
        return d;
        // if (d?.response?.data?.length) {
        // return (this.petrolRates = d?.response?.data || [])
        // }
        // this.petrolModal = true
        // this.petrolRatesLoading = false
        // return d
      },
      graphicalQueryFormat() {
        const data = {
          company: this.company,
          consumptionRate: this.consumptionRate,
          options: this.optionsValues,
          title1: this.title1,
          title2: this.title2,
          title3: this.title3,
          titleSavings: this.titleSavings,
          trailers: this.trailersUsedList,
          // trailers: this.trailers,
          usageDates: this.usageDates,
          usageStats: this.usageStatistics,
        };

        console.log(data);
        const json = JSON.stringify(data);
        const encoded = btoa(json);
        return encoded;
      },
      // onCancelRangePicker() {
      //   this.usageDates = Array.isArray(this.usageDatesPrevious)
      //     ? [...this.usageDatesPrevious]
      //     : this.usageDatesPrevious
      //   this.usageDatesPrevious = null
      //   this.rangeModal = false
      //   this.title2 = this.titleDateFormat()
      // },
      onCompanySelect(v) {
        console.log(v);
        // if (!this.title1) {
        this.title1 = `${v.name.trim().toUpperCase()} - ENERGY REPORT`;
        localStorage.setItem("energy-company", v.id);
        // }
      },
      onOpenGraphical() {
        const q = this.graphicalQueryFormat();
        window.open(`/energy?d=${q}`, "_blank");
      },
      async onPetrolLookup() {
        this.petrolModal = true;
        if (this.petrolRates?.length) {
          return;
        }
        this.petrolRatesLoading = true;
        const data = await this.getPetrolRates();
        const rates = data?.length ? [...data] : [];
        this.petrolRates = rates?.sort((a, b) => a?.date - b?.date);
        this.petrolRatesLoading = false;
      },
      onPetrolRateSelection(rate) {
        this.petrolRate = rate?.value || null;
        this.petrolModal = false;
      },
      onResize() {
        const containerWidth =
          this.$refs?.previewContainer?.$el?.clientWidth || 0;
        if (containerWidth > 0) {
          this.previewScale = containerWidth / 1100;
        }
      },

      // TODO
      // TODO
      // TODO
      // TODO
      // save settings company, heading 1, project, savings title, options,
      // settingsLoad() {
      //   const validIntervalSettings = ['day', 'minute']
      //   const intervalSetting = localStorage.getItem('usage-interval')
      //   if (validIntervalSettings.includes(intervalSetting)) {
      //     this.interval = intervalSetting
      //   }
      //   const validPeriodSettings = ['custom', 'range', 'month']
      //   const periodSetting = localStorage.getItem('usage-period')
      //   if (validPeriodSettings.includes(periodSetting)) {
      //     this.period = periodSetting
      //   }
      // },
      // settingsSave() {
      //   localStorage.setItem('usage-interval', this.interval)
      //   localStorage.setItem('usage-filetype', this.period)
      // },
      // onSaveRangePicker() {
      //   this.usageDatesPrevious = null
      //   this.rangeModal = false
      //   this.title2 = this.titleDateFormat()
      // },
      // onShowRangePicker() {
      //   this.rangeModal = true
      //   this.usageDatesPrevious = Array.isArray(this.usageDates)
      //     ? [...this.usageDates]
      //     : this.usageDates
      // },
      titleDateFormat() {
        return this.usageDatesFormat();
        if (this.usageDates?.length !== 2) {
          return null;
        }
        const [start, end] = this.usageDates;
        const [startYear, startMonth, startDate] = start.split("-");

        const [endYear, endMonth, endDate] = end.split("-");
        let startString = monthFromDate(startMonth);
        if (startDate) {
          startString += ` ${parseInt(startDate, 10)}${ordinalFromNumber(
            startDate
          )}`;
        }
        if (startYear) {
          startString += ` ${startYear}`;
        }

        let endString = monthFromDate(endMonth);
        if (endDate) {
          endString += ` ${parseInt(endDate, 10)}${ordinalFromNumber(endDate)}`;
        }
        if (endYear) {
          endString += ` ${endYear}`;
        }

        let title = startString.toUpperCase();

        if (startString !== endString) {
          title += ` - ${endString.toUpperCase()}`;
        }
        return title;
      },

      usageDatesFormat() {
        if (!this.usageDates?.length) {
          return null;
        }

        // const [start, end] = this.usageDates;
        const start = this.usageDates[0];
        const [startYear, startMonth, startDate] = start.split("-");

        if (this.period === "month") {
          return `${startMonth}/${startYear}`;
        }
        if (this.period === "range" || this.period === 'custom' && this?.usageDates?.length < 3) {
          if (!this.usageDates?.[1] || start === this.usageDates?.[1]) {
            return startDate
              ? `${startMonth}/${startDate}/${startYear}`
              : `${startMonth}/${startYear}`;
          }
          const [endYear, endMonth, endDate] = this.usageDates[1].split("-");
          return `${startMonth}/${startDate}/${startYear} - ${endMonth}/${endDate}/${endYear}`;
        }
        if (this.period === "custom") {
          let dates = [];
          for (let d of this.usageDates) {
            const [dYear, dMonth, dDate] = d.split("-");
            const dstring = startDate
              ? `${dMonth}/${dDate}/${dYear}`
              : `${dMonth}/${dYear}`;
            dates.push(dstring);
          }
          return dates.join(", ");
        }
      },
    },
    async created() {
      if (!this?.selectedTrailers?.length) {
        console.log("No selected trailers found");
        return;
      }
      if (!this?.dates?.length) {
        console.log("Invalid Date Range");
        return;
      }

      if (!this.$store.state?.accountCompany?.id) {
        setTimeout(async () => {
          const company = await api.get("account/company");
          if (company.data) {
            console.log(company.data);
            this.$store.dispatch("setAccountCompany", company.data);
          }
          if (this.company?.company_name) {
            this.title1 = `${this.company.company_name.toUpperCase()} - ENERGY REPORT`;
          }
          this.isLoading = false;
        }, 1000);
      } else {
        if (this.company?.company_name) {
          this.title1 = `${this.company.company_name.toUpperCase()} - ENERGY REPORT`;
        }
        this.isLoading = false;
      }

      //IF COMPANY SELECT, STORE IN LOCAL (todo move to server)
      // const companyId = localStorage.getItem('energy-company')
      // if (companyId) {
      //   const selected = this.companies.find(c => c.id == companyId)
      //   if (selected) {
      //     this.company = { ...selected }
      //   }
      // }

      //TODO: may need to come back and make adjustments
      // this.usageDates =
      //   this.dates.length === 1
      //     ? [this.dates[0], this.dates[0]]
      //     : [...this.dates];
      this.usageDates = [...this.dates];

      this.title2 = this.titleDateFormat();
      // console.log(JSON.stringify(this.selectedTrailers))
      let trailers = {};
      let trailersById = {};
      this.selectedTrailers.forEach((trailer) => {
        trailers = {
          ...trailers,
          [trailer.id]:
            this.$store.state?.trailerMap?.[trailer.id]?.label || trailer.name,
        };
        trailersById = { ...trailersById, [trailer.id]: trailer };
      });
      this.trailers = { ...trailers };
      this.trailersById = { ...trailersById };
    },
    mounted() {
      this.$nextTick(() => this.onResize());
    },
  };
</script>
<template>
  <v-card class="default-dialog">
    <v-icon color="primary" @click="$emit('close')" class="close-btn">mdi-close</v-icon>
    <v-card-title class="primary--text"> ENERGY REPORT </v-card-title>
    <v-card-text class="pa-6" style="height: 80vh; max-width: 1200px; overflow-y: auto">
      <v-progress-linear v-if="isLoading" color="primary" indeterminate></v-progress-linear>
      <v-row v-else class="mb-12">
        <v-col v-if="hasEpsTrailer" cols="12" class="d-flex align-center justify-start error--text text-left font-weight-bold py-0">
          <v-alert type="error" style="width: 100%"> EPS trailer detected. Adjust threshold accordingly.</v-alert>
        </v-col>
        <!-- <v-dialog v-model="tempStatsModal" max-width="600" scrollable>
          <energy-usage-stats-card
            v-if="tempStatsModal"
            :usageStats="usageStatistics"
            @close="tempStatsModal = false"
          ></energy-usage-stats-card>
        </v-dialog>
 -->

        <v-col v-if="!selectedTrailers?.length" cols="12" class="pt-0">
          <v-alert type="error">No trailers selected!</v-alert>
        </v-col>

        <v-col cols="12" sm="6" class="d-flex flex-column align-start pt-0">
          <p class="text-left text-body-1 primary--text font-weight-bold mb-1 mt-4">
            Company
            <v-btn color="primary" dense outlined icon x-small tile to="/account" style="width: 40px" class="ml-12">
              <v-icon color="primary" x-small>mdi-pencil</v-icon>
            </v-btn>
          </p>
          <v-sheet color="transparent" class="d-flex flex-column align-start justify-start">
            <v-sheet v-for="(value, item) in companyDisplayed" :key="item" color="transparent" class="d-flex align-center justify-start">
              <v-sheet color="transparent" width="60" class="d-flex align-center">
                <p class="font-weight-bold mb-0">{{ item }}</p>
              </v-sheet>
              <v-sheet color="transparent" class="d-flex align-center">
                <p class="mb-0">{{ value }}</p>
              </v-sheet>
            </v-sheet>
          </v-sheet>
          <!-- <v-select v-model="companySelected" dense hide-details :items="companies" item-text="name" item-value="id" return-object @change="onCompanySelect"></v-select> -->
        </v-col>
        <v-col cols="12" sm="6" class="d-flex flex-column align-start pt-0">
          <p class="text-left text-body-1 primary--text font-weight-bold mb-1 mt-4">Report Dates</p>
          <p v-html="usageDatesFormat()" class="text-left text-body-1 font-weight-bold mb-1"></p>
          <!-- <v-btn color="primary" @click="onShowRangePicker" class="mt-0"
            ><v-icon color="secondary" left>mdi-clock-start</v-icon
            ><span class="secondary--text font-weight-bold pt-1">{{
              selectedDatesText ? selectedDatesText : 'CLICK TO SELECT'
            }}</span>
            <v-icon color="secondary" right>mdi-menu-down</v-icon>
          </v-btn> -->
          <!-- <v-dialog :value="rangeModal" max-width="400" persistent>
            <v-card>
              <v-card-text class="pa-4">
                <v-date-picker
                  v-model="usageDates"
                  full-width
                  range
                  :selected-items-text="selectedDatesText"
                  type="date"
                  scrollable
                  class=""
                ></v-date-picker>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" text @click="onCancelRangePicker"
                  >CANCEL</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn color="success" @click="onSaveRangePicker">SAVE</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
        </v-col>
        <v-col cols="12" class="d-flex flex-column align-start pt-0 mt-4">
          <p class="text-left text-body-1 primary--text font-weight-bold mb-1">Heading</p>
          <!-- hint="Populates on Company Selection" -->
          <v-text-field
            v-model="title1"
            clearable
            label="Heading line 1"
            outlined
            placeholder="COMPANY - ENERGY REPORT"
            persistent-hint
            persistent-placeholder
            style="width: 100%"
            class="mt-4"
          ></v-text-field>
          <!-- hint="Populates on Date Range Selection" -->
          <v-text-field
            v-model="title2"
            clearable
            label="Heading line 2"
            outlined
            placeholder="DATE START - END"
            persistent-hint
            persistent-placeholder
            style="width: 100%"
            class="mt-4"
          ></v-text-field>
          <v-text-field
            v-model="title3"
            clearable
            hint=""
            label="Heading line 3"
            outlined
            placeholder="''PROJECT TITLE''"
            persistent-hint
            persistent-placeholder
            style="width: 100%"
            class="mt-4"
          ></v-text-field>
          <v-text-field
            v-model="titleSavings"
            clearable
            hint=""
            label="Savings Title"
            outlined
            placeholder="YOU SAVED THIS WEEK!"
            persistent-hint
            persistent-placeholder
            style="width: 100%"
            class="mt-4"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="d-flex flex-column align-start pt-0">
          <p class="text-left text-body-1 primary--text font-weight-bold mb-4">Visibility Options</p>
          <v-sheet class="d-flex flex-wrap align-start justify-start">
            <v-checkbox v-for="(option, key) in options" :key="option.key" :label="options[key].label" v-model="options[key].value" class="mt-0 ml-4"></v-checkbox>
          </v-sheet>
        </v-col>

        <v-col cols="12" class="d-flex flex-wrap align-start pt-0">
          <v-row no-gutters>
            <v-col cols="12" sm="4">
              <v-sheet height="100%" min-height="160px" class="d-flex flex-column justify-space-between align-start mr-2 mb-4">
                <p class="text-left text-body-1 primary--text font-weight-bold mb-4">Consumption Rate</p>
                <v-sheet>
                  <v-text-field v-model="consumptionRate" min="0" outlined type="number" class="flex-shrink-1"> </v-text-field>
                </v-sheet>
              </v-sheet>
            </v-col>
            <!-- <v-col cols="12" sm="4">
              <v-sheet
                height="100%"
                min-height="160px"
                class="d-flex flex-column justify-space-between align-start mr-2 mb-4"
              >
                <v-sheet>
                  <p
                    class="text-left text-body-1 primary--text font-weight-bold mb-4"
                  >
                    Load Threshold
                  </p>
                  <v-sheet
                    v-if="hasEpsTrailer"
                    max-width="80%"
                    class="d-flex align-start justify-start error--text text-left"
                    style="line-height: 1rem"
                  >
                    <v-icon color="error" small class="mr-2 align-self-center"
                      >mdi-alert</v-icon
                    >EPS trailer detected. Adjust threshold accordingly.
                  </v-sheet>
                </v-sheet>
                <v-sheet>
                  <v-text-field
                    v-model="loadThreshold"
                    min="0"
                    outlined
                    type="number"
                    class="flex-shrink-1"
                  >
                  </v-text-field>
                </v-sheet>
              </v-sheet>
            </v-col> -->
            <v-col cols="12" sm="4">
              <v-sheet height="100%" min-height="160px" class="d-flex flex-column justify-space-between align-start mb-4">
                <p class="text-left text-body-1 primary--text font-weight-bold mb-2">Diesel Cost</p>
                <v-radio-group v-model="petrolRateType" hide-details row class="mb-2 mt-0">
                  <v-radio label="Manual" value="manual"></v-radio>
                  <v-radio label="Regional" value="region"></v-radio>
                </v-radio-group>
                <v-sheet v-if="petrolRateType === 'manual'" color="transparent" width="100%">
                  <v-text-field v-model="petrolRate" hide-details min="0" outlined placeholder="0.00" prefix="$" type="text" style="max-width: 200px"> </v-text-field>
                </v-sheet>
                <v-sheet v-if="petrolRateType === 'region'" color="transparent" width="100%" class="d-flex justfiy-start">
                  <v-dialog v-model="petrolModal" max-width="500" hide-overlay scrollable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" large outlined tile @click="onPetrolLookup" class="text-left rounded pl-2 pr-4" style="height: 55px; min-width: 200px">
                        <span class="mr-auto"> {{ petrolRateRegion || 'SELECT REGION' }}</span>
                        <v-icon large right>mdi-menu-down</v-icon></v-btn
                      >
                    </template>
                    <v-card v-if="petrolModal">
                      <v-card-title class="primary--text font-weight-bold">Diesel Rates</v-card-title>
                      <v-card-text class="pa-4 text-left" style="height: 400px" overflow-y: auto>
                        <div v-if="!petrolRates?.length">
                          <p>
                            {{ petrolRatesLoading ? 'Getting rates...' : 'No rates received' }}
                          </p>
                          <v-progress-circular v-if="petrolRatesLoading" color="primary" indeterminate class="mx-auto"></v-progress-circular>
                        </div>
                        <v-select v-if="petrolRegions?.length" v-model="petrolRateRegion" :items="petrolRegions" label="Region"></v-select>
                        <v-data-table
                          v-if="petrolRatesDisplayed?.length"
                          :headers="[
                            { text: 'Week of', value: 'date' },
                            { text: 'Price', value: 'diesel_price' },
                          ]"
                          hide-default-footer
                          :items-per-page="-1"
                          :items="petrolRatesDisplayed"
                        ></v-data-table>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="petrolModal = false">CLOSE</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-sheet>
                <p class="text-left mb-0 pl-2">
                  {{ petrolRateDetailText || ' &nbsp;' }}
                </p>
                <!-- when element select -->
                <!-- style="width: 100%" -->
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-sheet min-height="160px" width="100%" class="text-left text-body-1 primary--text font-weight-bold my-4">
            <v-sheet class="d-flex flex-row align-center mb-4">
              <p class="primary--text mb-0">Trailers</p>
              <v-btn icon color="primary" @click="collapseTrailers = !collapseTrailers"
                ><v-icon>{{ `mdi-menu-${collapseTrailers ? 'down' : 'up'}` }}</v-icon></v-btn
              ></v-sheet
            >
            <p v-if="collapseTrailers" class="black--text font-weight-light">
              Trailer list hidden. Click
              <v-icon color="primary">mdi-menu-up</v-icon> to expand
            </p>

            <v-row :style="`height: ${collapseTrailers ? '0px' : '100%'}; overflow: hidden`">
              <v-col v-for="trailerId in trailersDisplayed" :key="trailerId" cols="12" sm="6" md="4">
                <v-text-field
                  v-model="trailers[trailerId]"
                  clearable
                  :hint="`Trailer: ${trailersById?.[trailerId]?.name || '-'}`"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  type="text"
                  style="width: 100%"
                  class="mt-4"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>

        <v-col cols="12" class="d-flex flex-column align-start justify-start pt-0">
          <p class="text-left text-body-1 primary--text font-weight-bold mb-4">Preview</p>
          <v-sheet v-resize="onResize" ref="previewContainer" max-width="100%" class="ma-auto pa-2 align-self-center" style="overflow: hidden">
            <energy-report-preview
              :company="company"
              :consumptionRate="consumptionRate"
              :isPreview="true"
              :key="loadThreshold"
              :options="optionsValues"
              :scale="previewScale"
              :title1="title1"
              :title2="title2"
              :title3="title3"
              :titleSavings="titleSavings"
              :trailers="trailersUsedList"
              :usageDates="usageDates"
              :usageStats="usageStatistics"
            ></energy-report-preview>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <!-- <v-btn @click="titleDateFormat()">test</v-btn> -->
      <v-spacer></v-spacer>
      <!-- :disabled="!selectedTrailers?.length" -->
      <!-- <v-btn color="primary" disabled
        ><v-icon color="secondary" left>mdi-table</v-icon><span class="font-weight-bold pt-1">SPREADSHEET</span> <v-icon color="secondary" right>mdi-download</v-icon></v-btn
      > -->
      <v-btn color="primary" :disabled="!selectedTrailers?.length" @click="onOpenGraphical" class="ml-12"
        ><v-icon color="secondary" left>mdi-file-image</v-icon><span class="font-weight-bold pt-1">GRAPHICAL</span><v-icon color="secondary" left>mdi-open-in-new</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<style scoped></style>
